import { HttpClient } from '@shared/adapters/HttpClient';

/** Fila de GET /locations?product_ids=... */
export interface ReceiveLocationRow {
  id: number;
  code: string;
  product_id: number;
  stock: number;
  type?: { id: number; name: string } | null;
}

interface LocationsListResponse {
  data: ReceiveLocationRow[];
}

export class ProductLocationsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Ubicaciones donde hay stock de los productos indicados (misma query que picking / empaquetado masivo).
   */
  async getByProductIds(productIds: number[]): Promise<ReceiveLocationRow[]> {
    if (productIds.length === 0) return [];
    const unique = [...new Set(productIds)].sort((a, b) => a - b);
    const res = await this.httpClient.get<LocationsListResponse>('/locations', {
      product_ids: unique.join(','),
      per_page: 1000,
      order_by: 'id',
      order_direction: 'asc',
    });
    return Array.isArray(res.data) ? res.data : [];
  }
}
